import React, {useContext, useEffect} from 'react';
import Markup from "../../../../markup";
import Tooltip from "../../../Global/Tooltip";
import Toggle from "../../../Global/Toggle";
import Count from "../../../Global/Count";
import BuilderContext from "../../../../builder/hooks/context";
import {useMediaQuery} from "react-responsive";
import {device} from "../../../../const/device";
import { trackBeforeUnload, trackSubStage } from '../../../../utils/Analytics';

function DesignSize() {
    const { builder } = useContext(BuilderContext);
    const isTablet = useMediaQuery({ query: `(${device.tablet})` });
    const isMobile = useMediaQuery({ query: `(${device.mobileL})` });


  useEffect(() => {
    trackSubStage('Design', 'Size');
    trackBeforeUnload('Size');
  }, []);

    return(
        <>
            <Markup.Screen.Name.SpecItemSize>
                <Markup.Screen.Name.SpecItemText themeColor={builder.membersData.colorTheme}>Select Size{<Tooltip Icon={Markup.Global.Link.LinkHelpIcon} width={isTablet ? 320 : 366} offset={ isTablet ? -190 : -100} bottom>
                    <Markup.Screen.Color.HelpTextContainer>
                        {builder.manifest.notification['Notice-Spec']}
                    </Markup.Screen.Color.HelpTextContainer>
                </Tooltip>}</Markup.Screen.Name.SpecItemText>
                <Toggle active={typeof(builder.membersData.currentMember.data.size) === 'object'? builder.membersData.currentMember.data.size[0]?.toUpperCase(): builder.membersData.currentMember.data.size?.toUpperCase()} setActive={item => builder.membersData.updateMember({ data: { size: item } })} items={builder?.options?.size.map(item => item?.toUpperCase())} privewCircle />
            </Markup.Screen.Name.SpecItemSize>
        </>
    );

}

export default React.memo(DesignSize);